module.exports = __webpack_public_path__ + "static/media/edit.d6060b4a.svg";